import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  BottomNavigation,
  BottomNavigationAction,
  Paper,
} from '@mui/material';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import FlightTakeoffOutlinedIcon from '@mui/icons-material/FlightTakeoffOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import { DOCUMENT } from '../constants/documentTheme';
import {
  getPartnerNavKey,
  PARTNER_BOTTOM_NAV_HEIGHT,
  PARTNER_MOBILE_BOTTOM_TABS,
} from '../utils/partnerWorkspace';

const ICONS = {
  dashboard: DashboardOutlinedIcon,
  trips: FlightTakeoffOutlinedIcon,
  packages: Inventory2OutlinedIcon,
  requests: ForumOutlinedIcon,
  bookings: ConfirmationNumberOutlinedIcon,
};

const PartnerMobileBottomNav = ({ accent, ink, banner }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const activeKey = getPartnerNavKey(location.pathname) || 'dashboard';
  const tabAccent = accent || DOCUMENT.navAccent;
  const tabInk = ink || 'rgba(246,239,228,0.72)';
  const tabBg = banner || DOCUMENT.oxblood;

  return (
    <Paper
      component="nav"
      elevation={0}
      data-testid="partner-mobile-bottom-nav"
      sx={{
        display: { xs: 'block', md: 'none' },
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 30,
        borderRadius: 0,
        borderTop: '1px solid rgba(255,255,255,0.12)',
        bgcolor: tabBg,
        pb: 'env(safe-area-inset-bottom, 0px)',
      }}
    >
      <BottomNavigation
        showLabels
        value={PARTNER_MOBILE_BOTTOM_TABS.some((tab) => tab.key === activeKey) ? activeKey : false}
        onChange={(_event, value) => {
          const tab = PARTNER_MOBILE_BOTTOM_TABS.find((item) => item.key === value);
          if (tab) navigate(tab.to);
        }}
        sx={{
          height: PARTNER_BOTTOM_NAV_HEIGHT,
          bgcolor: 'transparent',
          '& .MuiBottomNavigationAction-root': {
            color: tabInk,
            minWidth: 0,
            px: 0.5,
            py: 0.75,
            fontFamily: DOCUMENT.sans,
            '&.Mui-selected': { color: tabAccent },
          },
          '& .MuiBottomNavigationAction-label': {
            fontSize: '0.62rem',
            letterSpacing: '0.04em',
            textTransform: 'uppercase',
            mt: 0.25,
            '&.Mui-selected': { fontSize: '0.62rem' },
          },
        }}
      >
        {PARTNER_MOBILE_BOTTOM_TABS.map((tab) => {
          const Icon = ICONS[tab.key];
          return (
            <BottomNavigationAction
              key={tab.key}
              value={tab.key}
              label={t(tab.labelKey)}
              icon={<Icon sx={{ fontSize: 22 }} />}
              data-testid={`partner-bottom-nav-${tab.key}`}
            />
          );
        })}
      </BottomNavigation>
    </Paper>
  );
};

export default PartnerMobileBottomNav;
